/**
 * FontConstants.ts
 */
var _a, _b, _c;
import { FontShadow, FontStroke } from "@lib/titan2/dist/game/control/properties/FontProperties";
/**
 * FontColour.ts
 */
export class FontColour {
}
_a = FontColour;
FontColour.DEFAULT_GRADIENT = ['#fff5a3', '#f6ff18', '#ff9306', '#ee6f00'];
FontColour.DEFAULT_GRADIENT_STOPS = [0.26, 0.52, 0.75, 0.9];
FontColour.DEFAULT_DIALOG = _a.DEFAULT_GRADIENT;
FontColour.DEFAULT_DIALOG_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.OPTIONS = _a.DEFAULT_GRADIENT;
FontColour.OPTIONS_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.DEFAULT_MESSAGING = "#ffffff";
FontColour.DEFAULT_WIN = [
    "#fff04a",
    "#ffdf00",
    "#ff790d"
];
FontColour.DEFAULT_WIN_STOPS = [0.3, 0.6, 0.9];
FontColour.FREE_SPIN_SYMBOL = ['#fdfeb3', '#fbd42e'];
FontColour.FREE_SPIN_SYMBOL_STOPS = [0.5, 0.7];
FontColour.TEST_BUTTON = ['#fdfeb3', '#fbd42e'];
FontColour.TEST_BUTTON_STOPS = [0.5, 0.7];
FontColour.SIGNPOSTING_TITLE = ['#fdfeb3', '#fbd42e'];
FontColour.SIGNPOSTING_TITLE_STOPS = [0.5, 0.7];
FontColour.SIGNPOSTING_BODY = ['#fdfeb3', '#fbd42e'];
FontColour.SIGNPOSTING_BODY_STOPS = [0.5, 0.7];
FontColour.BALANCE = _a.DEFAULT_MESSAGING;
FontColour.BALANCE_STOPS = [0.5, 0.7];
FontColour.BOTTOM_BAR = _a.DEFAULT_MESSAGING;
FontColour.BOTTOM_BAR_STOPS = [0.5, 0.7];
FontColour.MESSAGE_BAR = _a.DEFAULT_MESSAGING;
FontColour.MESSAGE_BAR_STOPS = [0.5, 0.7];
FontColour.CLOCK = _a.DEFAULT_MESSAGING;
FontColour.CLOCK_STOPS = [0.5, 0.7];
/////////////////////////////////////////////////        
FontColour.LOADER = ['#ffffff', "#fff310", '#fecf01'];
FontColour.LOADER_STOPS = [0.25, 0.45, 0.9];
FontColour.PLAY_BUTTON = _a.DEFAULT_GRADIENT;
FontColour.PLAY_BUTTON_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.COPYRIGHT = "#fbdaac";
FontColour.LOADER_WIN = _a.DEFAULT_GRADIENT;
FontColour.LOADER_WIN_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.LOADER_INFO_FIELD_LINE_1 = _a.DEFAULT_GRADIENT;
FontColour.LOADER_INFO_FIELD_LINE_1_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.LOADER_INFO_FIELD_LINE_2 = _a.DEFAULT_GRADIENT;
FontColour.LOADER_INFO_FIELD_LINE_2_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.AVAILABLE_WIN_LABEL = _a.DEFAULT_GRADIENT;
FontColour.AVAILABLE_WIN_LABEL_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.COLLECT_BUTTON = _a.DEFAULT_GRADIENT;
FontColour.COLLECT_BUTTON_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.COLLECT_BUTTON_LARGE_TEXT = _a.DEFAULT_GRADIENT;
FontColour.COLLECT_BUTTON_LARGE_TEXT_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.END_GAME_BUTTON = _a.DEFAULT_GRADIENT;
FontColour.END_GAME_BUTTON_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.PAY_TABLE_FULL_HOUSE_LABEL = _a.DEFAULT_GRADIENT;
FontColour.PAY_TABLE_CELL_LABEL = _a.DEFAULT_GRADIENT;
FontColour.PAY_TABLE_CELL_VALUE = _a.DEFAULT_GRADIENT;
FontColour.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_LABEL = _a.DEFAULT_GRADIENT;
FontColour.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_VALUE = _a.DEFAULT_GRADIENT;
FontColour.PAY_TABLE_CELL_EXCEEDED_LABEL = _a.DEFAULT_GRADIENT;
FontColour.PAY_TABLE_CELL_EXCEEDED_VALUE = _a.DEFAULT_GRADIENT;
FontColour.PAY_TABLE_FULL_HOUSE_LABEL_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.PAY_TABLE_CELL_LABEL_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.PAY_TABLE_CELL_VALUE_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_LABEL_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_VALUE_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.PAY_TABLE_CELL_EXCEEDED_LABEL_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.PAY_TABLE_CELL_EXCEEDED_VALUE_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.PAY_TABLE_BUTTON = ["#fffe00", "#ffc600"];
FontColour.PAY_TABLE_BUTTON_STOPS = [0, 1];
FontColour.TICKET_NUMBER = ["#f9c942", "#f69d3e"];
FontColour.TICKET_NUMBER_STOPS = [0.5];
FontColour.SLINGO_ANIMATION_2 = ['#fdfeb3', '#fbd42e'];
FontColour.SLINGO_ANIMATION_2_STOPS = [0.5, 0.7];
FontColour.SLINGO_ANIMATION_3 = ['#fdfeb3', '#fbd42e'];
FontColour.SLINGO_ANIMATION_3_STOPS = [0.5, 0.7];
FontColour.SLINGO_ANIMATION_4 = ['#fdfeb3', '#fbd42e'];
FontColour.SLINGO_ANIMATION_4_STOPS = [0.5, 0.7];
FontColour.SPIN_BUTTON = _a.DEFAULT_GRADIENT;
FontColour.SPIN_BUTTON_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.STANDARD_SPINS_REMAINING = _a.DEFAULT_GRADIENT;
FontColour.STANDARD_SPINS_REMAINING_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.PURCHASE_SPINS_REMAINING = _a.DEFAULT_GRADIENT;
FontColour.PURCHASE_SPINS_REMAINING_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.FREE_SPINS_REMAINING = _a.DEFAULT_GRADIENT;
FontColour.FREE_SPINS_REMAINING_STOP = _a.DEFAULT_GRADIENT_STOPS;
FontColour.SCATTER_WIN_ANIMATION_TITLE = ['#fdfeb3', '#fbd42e'];
FontColour.SCATTER_WIN_ANIMATION_TITLE_STOPS = [0.5, 0.7];
FontColour.SCATTER_WIN_ANIMATION_COUNTER = ['#fdfeb3', '#fbd42e'];
FontColour.SCATTER_WIN_ANIMATION_COUNTER_STOPS = [0.5, 0.7];
FontColour.BIG_WIN_VALUE = _a.DEFAULT_WIN;
FontColour.BIG_WIN_VALUE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.BIG_WIN_TITLE = _a.DEFAULT_WIN;
FontColour.BIG_WIN_TITLE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.FULL_HOUSE = _a.BIG_WIN_TITLE;
FontColour.FULL_HOUSE_STOPS = _a.BIG_WIN_TITLE_STOPS;
FontColour.GAME_SUMMARY_TITLE = _a.DEFAULT_WIN;
FontColour.GAME_SUMMARY_TITLE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.GAME_SUMMARY_CELL = _a.DEFAULT_WIN;
FontColour.GAME_SUMMARY_CELL_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.GAME_SUMMARY_TOTAL_WIN_TITLE = _a.DEFAULT_WIN;
FontColour.GAME_SUMMARY_TOTAL_WIN_TITLE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.GAME_SUMMARY_WIN = _a.DEFAULT_WIN;
FontColour.GAME_SUMMARY_WIN_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.GAME_OVER = `#592408`;
FontColour.GAME_MESSAGES = _a.DEFAULT_MESSAGING;
FontColour.GAME_MESSAGES_STOPS = [0.5, 0.7];
FontColour.SCATTER_PANEL_FIELD = ['#fdfeb3', '#fbd42e'];
FontColour.SCATTER_PANEL_FIELD_STOPS = [0.5, 0.7];
FontColour.TOTAL_WIN_TITLE = ['#fdfeb3', '#fbd42e'];
FontColour.TOTAL_WIN_TITLE_STOPS = [0.5, 0.7];
FontColour.TOTAL_WIN_VALUE = ['#fdfeb3', '#fbd42e'];
FontColour.TOTAL_WIN_VALUE_STOPS = [0.5, 0.7];
FontColour.FEATURE_TITLE = _a.DEFAULT_WIN;
FontColour.FEATURE_TITLE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.FEATURE_HELP_TEXT = _a.DEFAULT_GRADIENT;
FontColour.FEATURE_HELP_TEXT_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.FISH_FOOD_FEATURE_HELP_TEXT = "#f69c32";
FontColour.FEATURE_RED_FISH_PRIZE_CHANGE = `#00ff00`;
FontColour.FEATURE_GREEN_FISH_PICKED_PRIZE = _a.DEFAULT_WIN;
FontColour.FEATURE_GREEN_FISH_PICKED_PRIZE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.FEATURE_GREEN_FISH_MISSED_PRIZE = ["#120940", "#1b497c"];
FontColour.FEATURE_GREEN_FISH_MISSED_PRIZE_STOPS = [0.2, 0.8];
FontColour.FEATURE_SELECTOR_PICK_A_BONUS = _a.DEFAULT_GRADIENT;
FontColour.FEATURE_SELECTOR_PICK_A_BONUS_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.FEATURE_SELECTOR_CHOICE = _a.DEFAULT_GRADIENT;
FontColour.FEATURE_SELECTOR_CHOICE_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.FISH_FOOD_PANEL_WIN_VALUES = _a.DEFAULT_WIN;
FontColour.FISH_FOOD_PANEL_WIN_VALUES_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.FISH_FOOD_PANEL_VALUES = '#eea843';
FontColour.FISH_FOOD_TOTAL_WIN_TITLE = _a.DEFAULT_WIN;
FontColour.FISH_FOOD_TOTAL_WIN_TITLE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.FISH_FOOD_TOTAL_WIN_VALUE = _a.DEFAULT_WIN;
FontColour.FISH_FOOD_TOTAL_WIN_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.FISH_FOOD_TURTLE_MISS = _a.DEFAULT_WIN;
FontColour.FISH_FOOD_TURTLE_MISS_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.FISH_FOOD_TURTLE_PICK = _a.DEFAULT_WIN;
FontColour.FISH_FOOD_TURTLE_PICK_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.FEATURE_GOLD_FISH_PICKED_PRIZE = _a.DEFAULT_WIN;
FontColour.FEATURE_GOLD_FISH_PICKED_PRIZE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.FEATURE_GOLD_FISH_MISSED_PRIZE = ["#120940", "#1b497c"];
FontColour.FEATURE_GOLD_FISH_MISSED_PRIZE_STOPS = [0.2, 0.8];
FontColour.GOLD_FISH_SYMBOL_VALUE = _a.DEFAULT_WIN;
FontColour.GOLD_FISH_SYMBOL_VALUE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.GOLD_FISH_SYMBOL_MULTIPLIED_VALUE = _a.DEFAULT_WIN;
FontColour.GOLD_FISH_SYMBOL_MULTIPLIED_VALUE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.GOLD_FISH_SPIN_COUNT_VALUE = _a.DEFAULT_GRADIENT;
FontColour.GOLD_FISH_SPIN_COUNT_VALUE_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.GOLD_FISH_WIN_COUNT_VALUE = _a.DEFAULT_WIN;
FontColour.GOLD_FISH_WIN_COUNT_VALUE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.GOLD_FISH_SPIN_COUNT_LABEL = _a.DEFAULT_GRADIENT;
FontColour.GOLD_FISH_SPIN_COUNT_LABEL_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.GOLD_FISH_WIN_COUNT_LABEL = _a.DEFAULT_GRADIENT;
FontColour.GOLD_FISH_WIN_COUNT_LABEL_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.GOLD_FISH_SPIN_WIN_VALUE = _a.DEFAULT_WIN;
FontColour.GOLD_FISH_SPIN_WIN_VALUE_STOPS = _a.DEFAULT_WIN_STOPS;
FontColour.GOLD_FISH_PAYTABLE_VALUE = _a.DEFAULT_GRADIENT;
FontColour.GOLD_FISH_PAYTABLE_VALUE_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.GOLD_FISH_MULTIPLIER_VALUE = _a.DEFAULT_GRADIENT;
FontColour.GOLD_FISH_MULTIPLIER_VALUE_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.GOLD_FISH_RESPIN_TITLE = _a.DEFAULT_GRADIENT;
FontColour.GOLD_FISH_RESPIN_TITLE_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.FEATURE_INFO_TITLE = _a.DEFAULT_GRADIENT;
FontColour.FEATURE_INFO_TITLE_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.FEATURE_INFO_HELP_TEXT = _a.DEFAULT_GRADIENT;
FontColour.FEATURE_INFO_HELP_TEXT_STOPS = _a.DEFAULT_GRADIENT_STOPS;
FontColour.FEATURE_INFO_TAP_TO_SKIP = _a.DEFAULT_GRADIENT;
FontColour.FEATURE_INFO_TAP_TO_SKIP_STOPS = _a.DEFAULT_GRADIENT_STOPS;
export class NormalisedFontStroke extends FontStroke {
}
;
/**
 * FontStrokes.ts
 */
export class FontStrokes {
    ;
}
_b = FontStrokes;
FontStrokes.DEFAULT_STROKE = new NormalisedFontStroke("#000000", 6);
FontStrokes.DEFAULT_MESSAGING = new FontStroke("#000000", 2);
FontStrokes.DEFAULT_WIN = new NormalisedFontStroke("#622c00", 6);
FontStrokes.OPTIONS = new FontStroke("#000000", 14);
FontStrokes.DEFAULT_DIALOG = new FontStroke("#000000", 6);
FontStrokes.FREE_SPIN_SYMBOL = new FontStroke("#180b06", 4);
FontStrokes.LOADER = new FontStroke("#7a4500", 8);
FontStrokes.TEST_BUTTON = new FontStroke("#180b06", 4);
FontStrokes.SLINGO_ANIMATION_2 = new FontStroke("#180b06", 4);
FontStrokes.SLINGO_ANIMATION_3 = new FontStroke("#180b06", 4);
FontStrokes.SLINGO_ANIMATION_4 = new FontStroke("#180b06", 4);
FontStrokes.GAME_OVER = new FontStroke("#d37c2b", 20);
FontStrokes.BALANCE = _b.DEFAULT_MESSAGING;
FontStrokes.BOTTOM_BAR = _b.DEFAULT_MESSAGING;
FontStrokes.MESSAGE_BAR = _b.DEFAULT_MESSAGING;
FontStrokes.CLOCK = _b.DEFAULT_MESSAGING;
FontStrokes.GAME_MESSAGES = _b.DEFAULT_MESSAGING;
FontStrokes.PLAY_BUTTON = _b.DEFAULT_STROKE;
FontStrokes.VERSION = new FontStroke("#180b06", 4);
FontStrokes.GUIDE_BODY = new FontStroke("#180b06", 4);
FontStrokes.LOADER_WIN = new FontStroke("#000000", 28);
FontStrokes.LOADER_INFO_FIELD_LINE_1 = new FontStroke("#000000", 18);
FontStrokes.LOADER_INFO_FIELD_LINE_2 = new FontStroke("#000000", 18);
FontStrokes.AVAILABLE_WIN_LABEL = _b.DEFAULT_STROKE;
FontStrokes.COLLECT_BUTTON = _b.DEFAULT_STROKE;
FontStrokes.COLLECT_BUTTON_LARGE_TEXT = _b.DEFAULT_STROKE;
FontStrokes.END_GAME_BUTTON = _b.DEFAULT_STROKE;
FontStrokes.TICKET_NUMBER = new FontStroke("#180b06", 4);
FontStrokes.SPIN_BUTTON = _b.DEFAULT_STROKE;
FontStrokes.FULL_HOUSE = new FontStroke("#165347", 8);
FontStrokes.SCATTER_WIN_ANIMATION_TITLE = new FontStroke("#180b06", 8);
FontStrokes.SCATTER_WIN_ANIMATION_COUNTER = new FontStroke("#180b06", 8);
FontStrokes.GAME_SUMMARY_TOTAL_WIN_TITLE = _b.DEFAULT_WIN;
FontStrokes.GAME_SUMMARY_TITLE = _b.DEFAULT_WIN;
FontStrokes.GAME_SUMMARY_CELL = _b.DEFAULT_WIN;
FontStrokes.GAME_SUMMARY_WIN = _b.DEFAULT_WIN;
FontStrokes.PAY_TABLE_BUTTON = new FontStroke("#983600", 8);
FontStrokes.PAYTABLE_LABEL_STROKE = new FontStroke("#000000", 4);
FontStrokes.PAY_TABLE_FULL_HOUSE_LABEL = _b.PAYTABLE_LABEL_STROKE;
FontStrokes.PAY_TABLE_CELL_LABEL = _b.PAYTABLE_LABEL_STROKE;
FontStrokes.PAY_TABLE_CELL_VALUE = _b.PAYTABLE_LABEL_STROKE;
FontStrokes.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_LABEL = _b.PAYTABLE_LABEL_STROKE;
FontStrokes.PAY_TABLE_CELL_CURRENT_HIGHLIGHT_VALUE = _b.PAYTABLE_LABEL_STROKE;
FontStrokes.PAY_TABLE_CELL_EXCEEDED_LABEL = _b.PAYTABLE_LABEL_STROKE;
FontStrokes.PAY_TABLE_CELL_EXCEEDED_VALUE = _b.PAYTABLE_LABEL_STROKE;
FontStrokes.SPIN_COUNTER = new FontStroke("#000000", 7);
FontStrokes.STANDARD_SPINS_REMAINING = _b.SPIN_COUNTER;
FontStrokes.PURCHASE_SPINS_REMAINING = _b.SPIN_COUNTER;
FontStrokes.FREE_SPINS_REMAINING = _b.SPIN_COUNTER;
FontStrokes.FEATURE_TITLE = _b.DEFAULT_WIN;
FontStrokes.FEATURE_HELP_TEXT = _b.DEFAULT_STROKE;
FontStrokes.FISH_FOOD_FEATURE_HELP_TEXT = new NormalisedFontStroke("#3c1e14", 6);
FontStrokes.FEATURE_RED_FISH_PRIZE_CHANGE = _b.DEFAULT_WIN;
FontStrokes.FEATURE_GREEN_FISH_PICKED_PRIZE = _b.DEFAULT_WIN;
FontStrokes.FEATURE_SELECTOR_PICK_A_BONUS = _b.DEFAULT_STROKE;
FontStrokes.FEATURE_SELECTOR_CHOICE = _b.DEFAULT_STROKE;
FontStrokes.FISH_FOOD_PANEL_WIN_VALUES = _b.DEFAULT_WIN;
FontStrokes.FISH_FOOD_PANEL_VALUES = new NormalisedFontStroke('#3f1c00', 6);
FontStrokes.FISH_FOOD_TOTAL_WIN_TITLE = _b.DEFAULT_WIN;
FontStrokes.FISH_FOOD_TOTAL_WIN_VALUE = _b.DEFAULT_WIN;
FontStrokes.FISH_FOOD_TURTLE_MISS = _b.DEFAULT_WIN;
FontStrokes.FISH_FOOD_TURTLE_PICK = _b.DEFAULT_WIN;
FontStrokes.FEATURE_GOLD_FISH_PICKED_PRIZE = _b.DEFAULT_WIN;
FontStrokes.FEATURE_GOLD_FISH_MISSED_PRIZE = _b.DEFAULT_WIN;
FontStrokes.GOLD_FISH_SYMBOL_VALUE = _b.DEFAULT_WIN;
FontStrokes.GOLD_FISH_SYMBOL_MULTIPLIED_VALUE = _b.DEFAULT_WIN;
FontStrokes.GOLD_FISH_SPIN_COUNT_VALUE = _b.DEFAULT_STROKE;
FontStrokes.GOLD_FISH_SPIN_COUNT_LABEL = _b.DEFAULT_STROKE;
FontStrokes.GOLD_FISH_WIN_COUNT_LABEL = _b.DEFAULT_STROKE;
FontStrokes.GOLD_FISH_SPIN_WIN_VALUE = _b.DEFAULT_WIN;
FontStrokes.GOLD_FISH_WIN_COUNT_VALUE = _b.DEFAULT_WIN;
FontStrokes.GOLD_FISH_PAYTABLE_VALUE = _b.DEFAULT_STROKE;
FontStrokes.GOLD_FISH_MULTIPLIER_VALUE = _b.DEFAULT_STROKE;
FontStrokes.GOLD_FISH_RESPIN_TITLE = _b.DEFAULT_STROKE;
FontStrokes.BIG_WIN_VALUE = _b.DEFAULT_WIN;
FontStrokes.BIG_WIN_TITLE = new FontStroke("#000000", 8);
FontStrokes.FEATURE_INFO_TITLE = _b.DEFAULT_STROKE;
FontStrokes.FEATURE_INFO_HELP_TEXT = _b.DEFAULT_STROKE;
FontStrokes.FEATURE_INFO_TAP_TO_SKIP = _b.DEFAULT_STROKE;
/**
 * FontShadows.ts
 */
export class FontShadows {
}
_c = FontShadows;
FontShadows.COPYRIGHT = new FontShadow("#000000", 3, 45, 1, 4);
FontShadows.DEFAULT_MESSAGING = new FontShadow("#000000", 6, 45, 1, 4);
FontShadows.BALANCE = _c.DEFAULT_MESSAGING;
FontShadows.BOTTOM_BAR = _c.DEFAULT_MESSAGING;
FontShadows.MESSAGE_BAR = _c.DEFAULT_MESSAGING;
FontShadows.CLOCK = _c.DEFAULT_MESSAGING;
FontShadows.GAME_MESSAGES = _c.DEFAULT_MESSAGING;
export class FontFilter {
}
/**
 * BitmapFontStyles.ts
*/
export class BitmapFontStyles {
}
BitmapFontStyles.TICKET_SYMBOL = {
    fontName: "numbersOnlyBase", align: "center", letterSpacing: -16
};
BitmapFontStyles.TICKET_SYMBOL_DAB_HIGHLIGHT = {
    fontName: "numbersOnlyBase", align: "center", letterSpacing: -16
};
BitmapFontStyles.TICKET_SYMBOL_WILD_HIGHLIGHT = {
    fontName: "numbersOnlyWild", align: "center", letterSpacing: -16
};
BitmapFontStyles.TICKET_SYMBOL_SUPER_WILD_HIGHLIGHT = {
    fontName: "numbersOnlySuperWild", align: "center", letterSpacing: -16
};
BitmapFontStyles.REEL_SYMBOL = {
    fontName: "numbersOnlyBase", align: "center", letterSpacing: -16
};
